module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/khb.component.css
// module id = ./src/app/khb.component.css
// module chunks = main